import React from "react";
import { StudentsCard } from "./StudentsCard";
import { StudentsUIProvider } from "./StudentsUIContext";

export function StudentsPage({
  date,
  section,
  sectionId,
  courseHour
}) {
  return (
    <StudentsUIProvider date={date} sectionId={sectionId} courseHour={courseHour}>
      <StudentsCard
        date={date}
        section={section}
        courseHour={courseHour}
      />
    </StudentsUIProvider>
 );
}